export var getBetSlipOdds = function (displayOdds) {
    return (displayOdds && displayOdds.american)
        ? displayOdds.american.replace("−", "-")
        : "0";
};
//# sourceMappingURL=getBetSlipOdds.js.map